import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TagComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        TagComponent,
    ],
    exports: [
        TagComponent,
    ],
})

export class TagModule {}
